export default {"src":"/_next/static/media/chevronRightUiLight_16.1bfe97e6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};